import { Stack } from '@mui/material';
import { FC } from 'react';
import { FormActionTypeEnum, PermissionFormModel, RecordPermissionModel } from '../models';
import TreeViewItem from './TreeViewItem';

const TreeView: FC<{
  data: RecordPermissionModel;
  parentPath: string;
}> = ({ data, parentPath }) => {
  return (
    <Stack direction={'column'}>
      {Object.values(data).map((item, index) => {
        return <TreeViewItem key={index} data={item} parentPath={parentPath} />;
      })}
    </Stack>
  );
};

export default TreeView;
